import React, {Component} from 'react';
import {BrowserRouter, Route, Switch, withRouter} from 'react-router-dom';
import {PATH} from '../../constants';
import SignIn from '../../Containers/SignIn';
import ForgotPassword from '../../Containers/ForgotPassword';
import SuccessModal from '../../Containers/Modals/SuccessModal';
import {connect} from 'react-redux';

class GlobalRoutes extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <BrowserRouter>
          <Switch>
            <Route
              exact
              path={PATH.FORGOT_PASSWORD}
              component={ForgotPassword}
            />
            <Route path="*" component={SignIn} />
          </Switch>
          <SuccessModal {...this.props} />
        </BrowserRouter>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const GlobalWithRoutes = withRouter(GlobalRoutes);
export default connect(mapStateToProps, mapDispatchToProps)(GlobalWithRoutes);
